import {Grid, Typography} from '@mui/material';
import React, {FC} from 'react';
import {localizedInterpolation} from '../../../../../i18n/i18n';
import {getValueLengthWithUnitByCulture} from '../../../../../utilities/helpers/culture-settings-helper';
import {useSelector} from 'react-redux';
import {AppState} from '../../../../../state/store';

interface PropsFromParent {
  showPlacementWarning: boolean;
}
export const PlacementWarningRow: FC<PropsFromParent> = React.memo((props) => {
  const {unitsId} = useSelector((store: AppState) => store.urlSettingsReducer.cultureUrlParameters);

  return (
    <>
      {props.showPlacementWarning ? (
        <>
          <Grid item xs={12}>
            <Typography variant="body3" color="error">
              {localizedInterpolation('PlacementWarningX', {value1: getValueLengthWithUnitByCulture(unitsId, '70')})}
            </Typography>
          </Grid>
        </>
      ) : (
        <></>
      )}
    </>
  );
});
